import { OnboardingLayout } from '@/components/layouts/onboarding-layout'
import {
  authenticateBeforeLoad,
  loadAuthenticatedUser,
} from '@/shared/utils/route-utils/auth-route-config'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_onboarding')({
  beforeLoad: async ({ location }) => authenticateBeforeLoad(location),
  loader: async ({ context: { queryClient, userId } }) =>
    loadAuthenticatedUser(queryClient, userId),
  component: OnboardingComponent,
})

function OnboardingComponent() {
  return (
    <OnboardingLayout>
      <Outlet />
    </OnboardingLayout>
  )
}
